import { render, staticRenderFns } from "./ButtonLogout.vue?vue&type=template&id=afacce00&scoped=true"
import script from "./ButtonLogout.vue?vue&type=script&lang=js"
export * from "./ButtonLogout.vue?vue&type=script&lang=js"
import style0 from "./ButtonLogout.vue?vue&type=style&index=0&id=afacce00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afacce00",
  null
  
)

export default component.exports